import { render, staticRenderFns } from "./SupplierOrderFilters.vue?vue&type=template&id=982aa7f8&"
import script from "./SupplierOrderFilters.vue?vue&type=script&lang=js&"
export * from "./SupplierOrderFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports